import { styled } from "linaria/react";

export const OrganizationNameContainer = styled.div`
  grid-area: name;
  color: var(--color-primary);
  font-weight: bold;
`;
